export enum SkeletonVariant {
  Text = 'text',
  Rectangular = 'rectangular',
  Circular = 'circular',
  Rounded = 'rounded',
}

export enum SkeletonGradientDirection {
  ToRight = 'to right',
  ToLeft = 'to left',
  ToTop = 'to top',
  ToBottom = 'to bottom',
  DiagonalToTopRight = 'to top right',
  DiagonalToTopLeft = 'to top left',
  DiagonalToBottomRight = 'to bottom right',
  DiagonalToBottomLeft = 'to bottom left',
}
